import type { GetStaticPropsContext } from 'next';

import {
  fetchLegalIndexProps,
  type LegalIndexProps,
} from '#/lib/sanity/fetchers/fetchLegalIndexProps';
import { LegalIndex } from '#/components/LegalIndex';

export const config = {
  maxDuration: 30,
};

export async function getStaticProps({ draftMode }: GetStaticPropsContext) {
  const props = await fetchLegalIndexProps(draftMode);

  if (!props.page) {
    return { notFound: true };
  }

  return { props };
}

export default function LegalIndexPage(props: LegalIndexProps) {
  return <LegalIndex page={props.page} />;
}
